import React from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { Content, SectionHeading } from "../../../../../ContributionActivity/Components/ViewContribution/styles";
import { ComponentDivider } from "../../../../../ContributionActivity/Components/ViewContribution/Components/ContributionType/styles";
import formatter from "../../../../../../../../utils/formatter";
import { AccountLinkWrapper } from '../../../ContributionType/styles';
import { TypeValue } from "../../styles";
import { GiftWrapper, LetterOfAuthorization, ContentBoldUnderline, AuthorizationText, FundingList, CorporationInstructions, FontBoldText, ContentWrap } from "../../../../../ContributionActivity/Components/ViewContribution/Components/FundingInstructions/styles";
import { getPrimaryAccount } from "../../../../../../../../utils/sessionUtil";
import { milliToDate, milliToTime, recordError } from "../../../../../../../../utils/commonUtil";
import { decodeName } from "../../../../../../../../utils/nameFormatter";
import { todayDate, getpwUrl } from "../../../../../../../../utils/commonUtil";
import Theme from "../../../../../../../../styles/theme";
import { DownloadTag } from "../../../../../ContributionsDashboard/components/DownloadContributions/styles.js";
import { fundingInstructionsLOAState } from "../../../../selectors";
let assetMfLoa = [];
let assetSgLoa = [];
let assetMfSloa = [];
let assetSgSloa = [];
let assetOutMF = [];
let assetOutSG = [];
let check = [];
let checkDaf = [];
let wire = [];
let stockCert = [];
let isCorporation = false;
const basePath = process.env.PUBLIC_URL || '/';
const envURL = process.env.REACT_APP_DRUPAL_BASE_URL;

export class ContributionType extends React.Component {
  constructor(props) {
    super(props);
    isCorporation = false;
  }

  clickAssetHeldMF = (data, name, path) => {
    try {
      localStorage[name] = JSON.stringify(data);
      if (process.env.REACT_APP_NODE_ENV !== "development") {
        path = basePath + path;
      }
      path = path + '?isRefresh=true';
      const win = window.open(path, '_blank');
      win.focus();
    } catch (error) {
      recordError(error);
    }
  }

  fundInfoJson = (contribution, isSecurity) => {
    let data = [];
    contribution.fundInformation.map((fund) => {
        data.push({
            envURL: envURL,
            logAcName: getPrimaryAccount().accountName,
            logAcNum: getPrimaryAccount().accountNumber,
            firm: contribution.holdingFirm ? contribution.holdingFirm : '',
            name: contribution.Donors[0].name,
            donorName: contribution.Donors[1].name,
            accountNumber: contribution.accountNumber,
            type: contribution.type,
            firstName: contribution.Donors[1].firstName,
            lastName: contribution.Donors[1].lastName,
            ticker: fund.tickerSymbol,
            fundName: isSecurity ? fund.securityName : fund.fundName,
            fundNumber: fund.fundNumber,
            allShares: fund.allShare,
            shares: fund.numberofShares
          })
      });
      return data;
  }

  assetheldInfoJson = (contribution, isSecurity) => {
    let loa = [];
    let sloa = [];
    contribution.fundInformation.map((fund) => {
      loa.push({
            envURL: envURL,
            logAcName: getPrimaryAccount().accountName,
            logAcNum: getPrimaryAccount().accountNumber,
            firm: contribution.holdingFirm ? contribution.holdingFirm : '',
            name: contribution.Donors[0].name,
            donorName: contribution.Donors[1].name,
            accountNumber: contribution.VGAccountNumber,
            type: contribution.type,
            firstName: contribution.Donors[1].firstName,
            lastName: contribution.Donors[1].lastName,
            ticker: fund.tickerSymbol,
            fundName: isSecurity ? fund.securityName : fund.fundName,
            fundNumber: fund.fundNumber,
            allShares: fund.allShare,
            shares: fund.allShare ? null : fund.numberofShares
        });
        sloa.push({
          envURL: envURL,
          logAcName: getPrimaryAccount().accountName,
          logAcNum: getPrimaryAccount().accountNumber,
          donorName: contribution.Donors[1].name,
          accountNumber: contribution.VGAccountNumber,
      });
      });
      return { 'loaData': loa, 'sloaData': sloa };
  }

  checkWireInfo = (contribution, allocationData) => {
      let data = [];
      data.push({
        envURL: envURL,
        logAcName: getPrimaryAccount().accountName,
        logAcNum: getPrimaryAccount().accountNumber,
        name: contribution.Donors[0].name,
        donorName: contribution.Donors[1].name,
        type: contribution.type,
        firstName: contribution.Donors[1].firstName,
        lastName: contribution.Donors[1].lastName,
        allocationDetails: allocationData,
        amount: formatter({
          value: contribution.amount,
          fieldSuffix: "Dollars"
        }),
        drupalContent: this.props.drupalData && this.props.drupalData.wiringInstructions.description__value
      })
      return data;
  }
 
  renderContributionTypes = (contribution,name) => {
        if(contribution.type === 'Private Foundation' || contribution.type === 'Corporation'){
          isCorporation = true;
        }
        if (name === "Asset Held at Vanguard - Mutual Funds") {
            const data = this.assetheldInfoJson(contribution,0);
            assetMfLoa.push(data.loaData);
            assetMfSloa.push(data.sloaData);
        }

        if (name === "Asset Held at Vanguard - Securities") {
            const data = this.assetheldInfoJson(contribution,1);
            assetSgLoa.push(data.loaData);
            assetSgSloa.push(data.sloaData);
        }

        if (name === "Asset Held Outside Vanguard - Mutual Funds") {
            assetOutMF.push(this.fundInfoJson(contribution,0))
        }

        if (name === "Asset Held Outside Vanguard - Securities") {
            assetOutSG.push(this.fundInfoJson(contribution,1))
        }

        if (name === "Check or Electronic Bank Transfer"){
           if(contribution.type === 'Other donor-advised fund'){
            checkDaf.push({'amount': formatter({
              value: contribution.amount,
              fieldSuffix: "Dollars"
            })});
           } else {
            check.push(this.checkWireInfo(contribution,[]))
           }
        }

        if (name === "Wire") {
            let dataWire = [];
            let allocationData = this.props.allocationData;
            let data = [];
            for (const pool in allocationData.portfolioBuildersForm) {
              if (Object.prototype.hasOwnProperty.call(allocationData.portfolioBuildersForm, pool)) {
                if(allocationData.portfolioBuildersForm[pool]["Percentage"] > 0 )
                data.push({ 'name' : decodeName(pool), 'futureAllocPercentage': allocationData.portfolioBuildersForm[pool]["Percentage"] });
              }
            }
            for (const pool in allocationData.portfolioSolutionsForm) {
                if (Object.prototype.hasOwnProperty.call(allocationData.portfolioSolutionsForm, pool)) {
                  if(allocationData.portfolioSolutionsForm[pool]["Percentage"] > 0 )
                  data.push({ 'name' : decodeName(pool), 'futureAllocPercentage': allocationData.portfolioSolutionsForm[pool]["Percentage"] });
                }
            }
            for (const pool in allocationData.valueDrivenForm) {
                if (Object.prototype.hasOwnProperty.call(allocationData.valueDrivenForm, pool)) {
                  if(allocationData.valueDrivenForm[pool]["Percentage"] > 0 )
                  data.push({ 'name' : decodeName(pool), 'futureAllocPercentage': allocationData.valueDrivenForm[pool]["Percentage"] });
                }
            }
            wire.push(this.checkWireInfo(contribution, data));
        }

        if (name === "Stock Certificates") {
            stockCert.push(this.fundInfoJson(contribution, 1))
        }
  };

  navigateFAQ = () => {
    try {
      window.open(envURL + '/FAQs#voice-verification', '_blank');
    } catch (error) {
      recordError(error);
    }
  }

  render() {
    assetMfLoa = [];
    assetSgLoa = [];
    assetMfSloa = [];
    assetSgSloa = [];
    assetOutMF = [];
    assetOutSG = [];
    check = [];
    checkDaf = [];
    wire = [];
    stockCert = [];
    const contributionTypes  = this.props.contributionTypes;
    let transactionInfo = this.props.successData;
    if (process.env.REACT_APP_NODE_ENV === "development") {
      transactionInfo = {"assetHeld":[{
        "acNum": "56778734588",
        "isSLOAPresent": false
    },
    {
        "acNum": "345679088",
        "isSLOAPresent": true
    }],"transactionId":3355980}
    }
    let showLabel = "0";
    let showSecurityLabel = "0";
    if(contributionTypes){    
        if(contributionTypes.assetHeldatVG.mfSelected === true) contributionTypes.assetHeldatVG.mutualFund.map((contribution,index) => (this.renderContributionTypes(contribution,'Asset Held at Vanguard - Mutual Funds')))
        if(contributionTypes.assetHeldatVG.sgSelected === true) contributionTypes.assetHeldatVG.securityGift.map((contribution,index) => (this.renderContributionTypes(contribution,'Asset Held at Vanguard - Securities')))
        if(contributionTypes.assetOutsideVG.mfSelected === true) contributionTypes.assetOutsideVG.mutualFund.map((contribution,index) => (this.renderContributionTypes(contribution,'Asset Held Outside Vanguard - Mutual Funds')))
        if(contributionTypes.assetOutsideVG.sgSelected === true) contributionTypes.assetOutsideVG.securityGift.map((contribution,index) => (this.renderContributionTypes(contribution,'Asset Held Outside Vanguard - Securities')))
        if(contributionTypes.checkOrEBT.checkSelected === true) contributionTypes.checkOrEBT.checkEBTList.map((contribution,index) => (this.renderContributionTypes(contribution,'Check or Electronic Bank Transfer')))
        if(contributionTypes.wire.wireSelected === true) contributionTypes.wire.wireList.map((contribution,index) => (this.renderContributionTypes(contribution,'Wire')))
        if(contributionTypes.stockCertificate.stockSelected === true) contributionTypes.stockCertificate.stockCertificateList.map((contribution,index) => (this.renderContributionTypes(contribution,'Stock Certificates')))
    }
    return contributionTypes ? (
      <>
        { isCorporation ? 
          <CorporationInstructions width='100%'>
          <ContentWrap><FontBoldText>Are you contributing assets from a corporation or private foundation for the first time ?</FontBoldText></ContentWrap>
          <ContentWrap className='mb-10'>All first-time contributions from a corporation and/or private foundation must include an additional completed form. Each donating entity is only required to complete the form once, regardless of the number or types of contribution.</ContentWrap>
          <AccountLinkWrapper target='_blank' href={`${getpwUrl()}${'/sites/default/files/corporateResolution.pdf'}`} id={"anrDownloadTag"}>Open the form</AccountLinkWrapper>
          </CorporationInstructions>
          : ''
          }
        {contributionTypes.assetHeldatVG.mfSelected ?
          <>
            <SectionHeading fontSize="24px" marginBottom="15px" mobileFont="20px">Asset held at Vanguard - mutual funds</SectionHeading> 
            {
                assetMfLoa.map((mutualFund, index) => {
                  let loaStatus = [];
                  let isPresent = false;
                  loaStatus = transactionInfo.assetHeld && transactionInfo.assetHeld.length && transactionInfo.assetHeld.filter(fund => fund.acNum === mutualFund[0].accountNumber);
                  isPresent = loaStatus.length && loaStatus[0].isSLOAPresent;
                  if(isPresent){
                    return (
                      <LetterOfAuthorization width='100%'>
                      <ContentWrap>Your gift of Vanguard mutual fund share held at Vanguard does not require any additional paperwork, as Vanguard Charitable already has a standing Letter of authorization file for account XXXX{mutualFund[0].accountNumber.substr(mutualFund[0].accountNumber.length - 4)}.</ContentWrap>
                      <ContentWrap>Date and time of receipt: <FontBoldText>{loaStatus[0].receiptDateTime ? milliToDate(loaStatus[0].receiptDateTime): todayDate()} at {loaStatus[0].receiptDateTime ? milliToTime(loaStatus[0].receiptDateTime) : '2:00 AM'}, EDT</FontBoldText> </ContentWrap>
                      <ContentWrap>Trade cutoff for <FontBoldText>{loaStatus[0].tradeCutOffDate ? milliToDate(loaStatus[0].tradeCutOffDate) : todayDate()}</FontBoldText> is <FontBoldText> {loaStatus[0].tradeCutOffDate ? milliToTime(loaStatus[0].tradeCutOffDate) : '2:00 PM'},EDT</FontBoldText></ContentWrap>
                      <ContentWrap>Vanguard mutual fund contributions that are received after the trade cutoff time listed above will most likely be processed on the following business day.For more information, please call the Program at <FontBoldText>888-383-4483</FontBoldText> from 8:30AM to 5:00PM Eastern Time.</ContentWrap>
                      <ComponentDivider bottom='30px' mobileBottom='20px' top='30px' mobileTop='20px' />
                      </LetterOfAuthorization>
                    )
                  }else{
                    return (
                      <LetterOfAuthorization width='100%'>
                      <ContentWrap>Submit a <AuthorizationText color={Theme.fontColors.textColor}>Letter of Authorization</AuthorizationText> to complete this contribution of Vanguard mutual funds held in Vanguard or VBS account XXXX{mutualFund[0].accountNumber.substr(mutualFund[0].accountNumber.length - 4)}.</ContentWrap>
                      <FundingList>
                      <li><span>Determine type of authorization you are using:</span></li>
                      <ContentWrap marginLeft='18px' mL='15px'>Authorization <ContentBoldUnderline>for this transaction only</ContentBoldUnderline>:  <AccountLinkWrapper marginLeft="10px" onClick={() => this.clickAssetHeldMF(mutualFund, "assetMF", '/AssetheldMF')} id={"btnOpenOneTimeAccount"}>Open a one-time <AuthorizationText color={Theme.fontColors.primary}>Letter of Authorization</AuthorizationText></AccountLinkWrapper> </ContentWrap>
                      <ContentWrap marginLeft='35px' mL='30px'>IMPORTANT: If the aggregate value of the contribution <FontBoldText>exceeds $2million</FontBoldText> ,you must obtain additional authorization in the form of Vanguard voice verification, Signature guarantee or Medallion signature guarantee. <AccountLinkWrapper onClick={()=> this.navigateFAQ()} id={"btnClickHereForMore"}>Click here</AccountLinkWrapper> for more information.</ContentWrap>
                      <ContentWrap marginLeft='18px' mL='15px'>Authorization for <ContentBoldUnderline>this and future transactions</ContentBoldUnderline>:  <AccountLinkWrapper marginLeft="10px" onClick={() => this.clickAssetHeldMF(assetMfSloa[index], "assetMFSLOA", '/AssetheldMFSLOA')}>Open a <AuthorizationText id={"btnOpenAstandingLetter"} color={Theme.fontColors.primary}>Standing Letter of Authorization</AuthorizationText></AccountLinkWrapper> </ContentWrap>
                      <ContentWrap marginLeft='35px' mL='30px'>IMPORTANT: To Complete the <AuthorizationText color={Theme.fontColors.textColor}>Standing Letter of Authorization</AuthorizationText>, each signature must be witnessed by a <FontBoldText>notary public</FontBoldText>. The original documents must be received by Vanguard Charitable within 30days of the notary stamp.Once complete, this form will eliminate the need or future <AuthorizationText color={Theme.fontColors.textColor}>Letter of Authorizations</AuthorizationText> for contribution made from this fund. <FontBoldText>NOTE:</FontBoldText> Vanguard Charitable will never request a transfer of funds without receiving instruction from the donor to do so first.</ContentWrap>
                      <li><span>Choose and print your pre-generated authorization letter Once complete, return to Vanguard Charitable via email, mail or fax.</span></li>
                      </FundingList>
                      <ComponentDivider bottom='30px' mobileBottom='20px' top='30px' mobileTop='20px'/>
                      </LetterOfAuthorization>
                    )
                  }
                })
            }
            </>
          : ""}
        
        {contributionTypes.assetHeldatVG.sgSelected ?
          <>
            <SectionHeading fontSize="24px" marginBottom="15px" mobileFont="20px">Asset held at Vanguard - securities</SectionHeading>
            {
                assetSgLoa.map((securityGift, index) => {
                  let loaStatus = [];
                  let isPresent = false;
                  loaStatus = transactionInfo.assetHeld && transactionInfo.assetHeld.length && transactionInfo.assetHeld.filter(fund => fund.acNum === securityGift[0].accountNumber);
                  isPresent = loaStatus.length && loaStatus[0].isSLOAPresent;
                  if(isPresent){
                    return (
                      <LetterOfAuthorization width='100%'>
                      <ContentWrap>Your gift of securities held at Vanguard does not require any additional paperwork, as Vanguard Charitable already has a standing Letter of authorization file for account XXXX{securityGift[0].accountNumber.substr(securityGift[0].accountNumber.length - 4)}.</ContentWrap>
                      <ContentWrap>Date and time of receipt: <FontBoldText>{loaStatus[0].receiptDateTime ? milliToDate(loaStatus[0].receiptDateTime) : todayDate()} at {loaStatus[0].receiptDateTime ? milliToTime(loaStatus[0].receiptDateTime) : '2:00 AM'}, EDT</FontBoldText> </ContentWrap>
                      <ContentWrap>Trade cutoff for <FontBoldText>{loaStatus[0].tradeCutOffDate ? milliToDate(loaStatus[0].tradeCutOffDate) : todayDate()}</FontBoldText> is <FontBoldText> {loaStatus[0].tradeCutOffDate ? milliToTime(loaStatus[0].tradeCutOffDate) : '2:00 PM'},EDT</FontBoldText></ContentWrap>
                      <ContentWrap>Vanguard mutual fund contributions that are received after the trade cutoff time listed above will most likely be processed on the following business day. For more information, please call the Program at <FontBoldText>888-383-4483</FontBoldText> from 8:30AM to 5:00PM Eastern Time.</ContentWrap>
                      <ComponentDivider bottom='30px' mobileBottom='20px' top='30px' mobileTop='20px'/>
                      </LetterOfAuthorization>
                    )
                  }else{
                    return (
                      <LetterOfAuthorization width='100%'>
                      <ContentWrap>Submit a <AuthorizationText color={Theme.fontColors.textColor}>Letter of Authorization</AuthorizationText> to complete this contribution of securities held at Vanguard Brokerage Services in account XXXX{securityGift[0].accountNumber.substr(securityGift[0].accountNumber.length - 4)}.</ContentWrap>
                      <FundingList>
                      <li><span>Determine type of authorization you are using:</span></li>
                      <ContentWrap marginLeft='18px' mL='15px'>Authorization <ContentBoldUnderline>for this transaction only</ContentBoldUnderline>: <AccountLinkWrapper id={"btnOpenAoneTimeLetter"} marginLeft="10px" onClick={() => this.clickAssetHeldMF(securityGift, "assetSG", '/AssetheldSecurity')}>Open a one-time <AuthorizationText color={Theme.fontColors.primary}>Letter of Authorization</AuthorizationText></AccountLinkWrapper> </ContentWrap>
                      <ContentWrap marginLeft='35px' mL='30px'>IMPORTANT: If the aggregate value of the contribution <FontBoldText>exceeds $2million</FontBoldText> ,you must obtain additional authorization in the form of Vanguard voice verification, Signature guarantee or Medallion signature guarantee. <AccountLinkWrapper onClick={()=> this.navigateFAQ()}>Click here</AccountLinkWrapper> for more information.</ContentWrap>
                      <ContentWrap marginLeft='18px' mL='15px'>Authorization <ContentBoldUnderline>for this and future transactions</ContentBoldUnderline>: <AccountLinkWrapper marginLeft="10px" onClick={() => this.clickAssetHeldMF(assetSgLoa[index], "assetSGSLOA", '/AssetheldSecuritySLOA')} id={"openAstandingLetter"} >Open a <AuthorizationText color={Theme.fontColors.primary}>Standing Letter of Authorization</AuthorizationText></AccountLinkWrapper> </ContentWrap>
                      <ContentWrap marginLeft='35px' mL='30px'>IMPORTANT: To Complete the <AuthorizationText color={Theme.fontColors.textColor}>Standing Letter of Authorization</AuthorizationText>, each signature must be witnessed by a <FontBoldText>notary public</FontBoldText>. The original documents must be received by Vanguard Charitable within 30days of the notary stamp.Once complete, this form will eliminate the need or future <AuthorizationText color={Theme.fontColors.textColor}>Letter of Authorizations</AuthorizationText> for contribution made from this fund. <FontBoldText>NOTE:</FontBoldText> Vanguard Charitable will never request a transfer of funds without receiving instruction from the donor to do so first.</ContentWrap>
                      <li><span>Choose and print your pre-generated authorization letter Once complete, return to Vanguard Charitable via email, mail or fax.</span></li>
                      </FundingList>
                      <ComponentDivider bottom='30px' mobileBottom='20px' top='30px' mobileTop='20px'/>
                      </LetterOfAuthorization>
                    )
                  }
                })
            }
            </>
          : ""}

        {contributionTypes.assetOutsideVG.mfSelected ?
          <>
            <SectionHeading fontSize="24px" marginBottom="15px" mobileFont="20px">Asset held outside Vanguard - mutual funds</SectionHeading>
           {  assetOutMF.map(mutualFund => (
             <>
             <LetterOfAuthorization width='100%'>
              <Content>Holding Firm: <TypeValue>{mutualFund[0].firm}</TypeValue></Content>
              <FundingList>
              <li><span>Contact your brokerage firm to determine if they are able to initiate electronic transfer of shares. If so, they may request for additional documentation specific to the holding firm</span></li>
              <li><span>If your brokerage is unable to initiate electronic transfer, please print and complete Letter of Authorization and obtain a Medallion signature guarantee.</span></li>
              <AccountLinkWrapper id={"btOopenAletterOfAutherization"} marginLeft='30px' data-test='account-link' onClick={() => this.clickAssetHeldMF(mutualFund, "assetOutMF", '/AssetOutsideMF')}>Open the <AuthorizationText color={Theme.fontColors.primary}>Letter of Authorization</AuthorizationText></AccountLinkWrapper>
              <li><span>Send form via registered mail, along with an account statement less than 90 days old from your current institution, to your Vanguard Charitable at our overnight/registered address: 2670 Warwick Avenue, Warwick, RI 02889-9509.</span></li>
              </FundingList>
            </LetterOfAuthorization>
            <ComponentDivider bottom='30px' mobileBottom='20px' top='30px' mobileTop='20px'/>
            </>
            ))
           }
          </>
         : ''}

        {contributionTypes.assetOutsideVG.sgSelected ?
          <>
            <SectionHeading fontSize="24px" marginBottom="15px" mobileFont="20px">Asset held outside Vanguard - securities</SectionHeading>
            { assetOutSG.map(security => (
              <>
               <LetterOfAuthorization width='100%'>
               <Content marginBottom="10px">Brokerage Firm: <TypeValue>{security[0].firm}</TypeValue></Content>
                <Content marginBottom="5px">If required by an originating broker, complete the Delivery Instructions for securities form and send to your broker or firm holding the securities. If not required, no further action is needed.</Content>
                <AccountLinkWrapper id={"btnOpenTheDeliveryInstruction"} data-test='acc-click1' onClick={() => this.clickAssetHeldMF(security, "assetOutSG", '/AssetsOutsideSecurity')}>Open the delivery instructions</AccountLinkWrapper>
                </LetterOfAuthorization>
                <ComponentDivider bottom='30px' mobileBottom='20px' top='30px' mobileTop='20px'/>
              </>
            ))
            }
          </>
          : ""}

        {check.length > 0 || checkDaf.length > 0 ?
          (
            <>
              {check.map((chec, index) => {
                return (
                  <div>
                    {
                      index === 0 ?
                        <>
                          <SectionHeading fontSize="24px" marginBottom="15px" mobileFont="20px">Check or electronic bank transfer</SectionHeading>
                          <Content marginBottom="20px">Print the form to accompany your check. This form also includes instructions on how to initiate your EBT.</Content>
                        </>
                        : ''
                    }
                    <LetterOfAuthorization width='100%'>
                    <GiftWrapper>
                      <Content marginBottom="10px">Amount: <TypeValue>{chec[0].amount}</TypeValue></Content>
                      <AccountLinkWrapper id={"btnOpenTheCheck"} data-test='acc2-link' onClick={() => this.clickAssetHeldMF(chec[0], "check", '/Check')}>Open the check or electronic bank transfer instructions</AccountLinkWrapper>
                    </GiftWrapper>
                    <ComponentDivider bottom='30px' mobileBottom='20px' top='30px' mobileTop='20px'/>
                    </LetterOfAuthorization>
                  </div>
                )
              })}
               {checkDaf.map((chec, index) => {
                return (
                  <div>
                    {
                      index === 0 ?
                        <>
                          {check.length === 0 ? <SectionHeading fontSize="24px" marginBottom="15px" mobileFont="20px">Check or electronic Bank transfer</SectionHeading> : ''}
                          <Content marginBottom="20px">Check from other another donor advised fund</Content>
                        </>
                        : ''
                    }
                    <LetterOfAuthorization width='100%'>
                    <Content>Amount: <TypeValue>{chec.amount}</TypeValue></Content>
                    <Content marginBottom="20px">Your contribution does not require additional paperwork be submitted to Vanguard Charitable. Please contact the sending donor-advised fund to complete the organization's required paperwork.</Content>
                    <ComponentDivider bottom='30px' mobileBottom='20px' top='30px' mobileTop='20px'/>
                    </LetterOfAuthorization>
                  </div>
                )
              })}
            </>
          )
          : ''}

        {wire.length > 0 ?
          (
            <>
              {wire.map((wir, index) => {
                return (
                  <div>
                    {
                      index === 0 ?
                        <>
                          <SectionHeading fontSize="24px" marginBottom="15px" mobileFont="20px">Wire</SectionHeading>
                          <Content marginBottom="20px">Provide the wire instructions to your financial Institution.</Content>
                        </>
                        : ''
                    }
                    <LetterOfAuthorization width='100%'>
                    <GiftWrapper>
                      <Content>Amount: <TypeValue>{wir[0].amount}</TypeValue></Content>
                      <AccountLinkWrapper id={"btnOpenTheWiringInstruction"} data-test='link-click' onClick={() => this.clickAssetHeldMF(wir[0], "wire", '/Wire')}>Open the wiring instructions</AccountLinkWrapper>
                    </GiftWrapper>
                    <ComponentDivider bottom='30px' mobileBottom='20px' top='30px' mobileTop='20px'/>
                    </LetterOfAuthorization>
                  </div>
                )
              })}
            </>
          )
          : ''}

        {stockCert.length > 0 ?
          (
            <>
              {stockCert.map((stock, index) => {
                return (
                  <div>
                    {
                      index === 0 ?
                        <>
                          <SectionHeading fontSize="24px" marginBottom="15px" mobileFont="20px">Stock Certificate</SectionHeading> 
                        </>
                        : ''
                    }
                    <LetterOfAuthorization width='100%'>
                    <FundingList>
                    <li>Print and complete the Letter of Authorization and obtain a Medallion signature guarantee for all registered owners.</li>
                    <GiftWrapper>
                      <AccountLinkWrapper id={"btnViewFundingInstruction"} marginLeft="30px" data-test='stock-click' onClick={() => this.clickAssetHeldMF(stock[0], "stockCert", '/StockCertificate')}>View Funding Instructions</AccountLinkWrapper>
                    </GiftWrapper>
                    <li><span>Properly endorse the certificate by writing "Vanguard Brokerge Services" between the words "appoint" and "attorney" on the back of each certificate.</span></li>
                    <li><span>Fill in the current date and sign your name exactly as it appears on the front of the certificate. All registered owners must sign in the presence of an authorizing officer. A Medallion signature guarantee required on all the certificates.</span></li>
                    <li><span>Send all materials via registered mail to Vanguard Charitable at our overnight/registered address: 2670 Warwick Avenue, Warwick, RI 02889-9509.</span></li>
                    </FundingList>
                    </LetterOfAuthorization>
                    <ComponentDivider bottom='30px' mobileBottom='20px' top='30px' mobileTop='20px'/>
                  </div>
                  
                )
              })}
            </>
          )
          : ''}
      </>
    ) : '';
  }
}

ContributionType.propTypes = {
  contributionTypes: PropTypes.object,
  allocationData: PropTypes.object,
  drupalData: PropTypes.any,
  successData: PropTypes.object
}

export const mapStateToProps = state => ({
  ...fundingInstructionsLOAState(state.toJS())
});

export default withRouter(
  connect(
    mapStateToProps,
    null
  )(ContributionType)
);
